/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Body2Inputs */

const en_viewer_body2 = /** @type {(inputs: Viewer_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The tree also makes types explicit, which text does not. In raw JSON, 42 and "42" differ by two characters that are easy to skim past, and null, an empty string, and a missing key look similar enough to confuse when you are scanning quickly. Each node here carries its type, which turns a class of debugging question into something you can answer by looking.`)
};

const ko_viewer_body2 = /** @type {(inputs: Viewer_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`트리는 텍스트가 하지 못하는 일, 즉 타입을 명시적으로 만드는 일도 합니다. 원본 JSON에서 42와 "42"는 지나치기 쉬운 두 문자로 갈리고, null과 빈 문자열과 없는 키는 빠르게 훑을 때 혼동할 만큼 비슷하게 보입니다. 여기서는 각 노드가 자기 타입을 지니므로, 디버깅 질문의 한 부류가 그냥 보면 답이 나오는 것으로 바뀝니다.`)
};

const ja_viewer_body2 = /** @type {(inputs: Viewer_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ツリーはテキストができないこと、つまり型を明示することもやります。生の JSON では 42 と "42" は見落としやすい 2 文字で分かれ、null と空文字列と存在しないキーは、急いで目を通すときに混同するほど似て見えます。ここでは各ノードが自分の型を持つので、デバッグの問いの一群が、見れば答えの出るものに変わります。`)
};

/**
* | output |
* | --- |
* | "The tree also makes types explicit, which text does not. In raw JSON, 42 and \"42\" differ by two characters that are easy to skim past, and null, an empty str..." |
*
* @param {Viewer_Body2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_body2 = /** @type {((inputs?: Viewer_Body2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Body2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_body2(inputs)
	if (locale === "ko") return ko_viewer_body2(inputs)
	return ja_viewer_body2(inputs)
});